import React, { useState } from "react";
import { showError, showSuccess } from "../../utils/toastUtils";
import userAPI from "../../api/UserApi";
import { FiLock, FiShieldAlert } from "react-icons/fi";

function ChangePassword() {
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [errors, setErrors] = useState({});

  const validate = () => {
    const newErrors = {};

    if (!currentPassword) {
      newErrors.currentPassword = "Please Enter Current Password";
    } else if (currentPassword.length < 6) {
      newErrors.currentPassword = "Current Password must be at least 6 characters";
    }

    if (!newPassword) {
      newErrors.newPassword = "Please Enter New Password";
    } else if (newPassword.length < 6) {
      newErrors.newPassword = "New Password must be at least 6 characters";
    }

    if (!confirmPassword) {
      newErrors.confirmPassword = "Please Enter Confirm Password";
    }

    if (newPassword && confirmPassword && newPassword !== confirmPassword) {
      newErrors.confirmPassword = "New Password & Confirm Password must be same";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleDetailsSubmit = async (e) => {
    e.preventDefault();

    if (!validate()) return;

    const payload = {
      newPassword,
      currentPassword,
      confirmPassword,
    };

    try {
      const res = await userAPI.updatePassword(payload);
      if (res.code === 200) {
        showSuccess(res.message);
        setCurrentPassword("");
        setNewPassword("");
        setConfirmPassword("");
      } else {
        showError(res.message);
      }
    } catch (err) {
      showError(err.message);
    }
  };

  return (
    <div className="account-password-funky">
      <div className="password-card-wrapper">
        {/* Header Block Sticker */}
        <div className="password-card-header mb-4">
          <span className="badge-text-purple">SECURITY</span>
          <h4 className="password-title mt-2">Change Password</h4>
        </div>

        <form onSubmit={handleDetailsSubmit}>
          <div className="row g-4">
            {/* CURRENT PASSWORD */}
            <div className="col-12">
              <label className="funky-dash-label">Current Password</label>
              <div className="funky-dash-input-box">
                <FiLock className="input-icon-left" />
                <input
                  type="password"
                  value={currentPassword}
                  onChange={(e) => setCurrentPassword(e.target.value)}
                  className="funky-dash-input"
                  placeholder="••••••••"
                />
              </div>
              {errors.currentPassword && (
                <small className="text-danger d-block mt-1 fw-bold">{errors.currentPassword}</small>
              )}
            </div>

            {/* NEW PASSWORD */}
            <div className="col-md-6">
              <label className="funky-dash-label">New Password</label>
              <div className="funky-dash-input-box">
                <FiLock className="input-icon-left" />
                <input
                  type="password"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  className="funky-dash-input"
                  placeholder="Min 6 characters"
                />
              </div>
              {errors.newPassword && (
                <small className="text-danger d-block mt-1 fw-bold">{errors.newPassword}</small>
              )}
            </div>

            {/* CONFIRM PASSWORD */}
            <div className="col-md-6">
              <label className="funky-dash-label">Confirm New Password</label>
              <div className="funky-dash-input-box">
                <FiLock className="input-icon-left" />
                <input
                  type="password"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  className="funky-dash-input"
                  placeholder="Re-type New Password"
                />
              </div>
              {errors.confirmPassword && (
                <small className="text-danger d-block mt-1 fw-bold">{errors.confirmPassword}</small>
              )}
            </div>
          </div>

          {/* ACTION BUTTON */}
          <div className="mt-4 pt-2">
            <button className="password-update-btn" type="submit">
              UPDATE PASSWORD ⚡
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default ChangePassword;